<title>register.IC_0001</title>
<layout>layout</layout>
<template>
  <div class="box no-margin">
    <div class="box-header">
      <h3
        slot="header"
        class="box-title">
        <span v-text="t('register.IC_0001')"/>
      </h3>
    </div>

    <div class="box-body clearfix">
      <div v-if="data === 'newIndividual'">
        <div>
          <new-individual />
        </div>
      </div>
      <div v-else>
        <div class="row">
          <div class="large-12 columns text-center">
            <process-model
              :models="processModel"
              :max-stage="maxStage"
              :current-stage="stage"
              @current-stage="val => stage = val"
            />
          </div>
        </div>

        <div>
          <keep-alive>
            <component
              :is="stageComponents[stage]"
              :tab="tab"
              :ge-contractor="geContractor"
              :ge-member-ids="geMemberIds"
              @stage-change="stageChanged"
              @ge-contractor="geContractor = true"
              @tab-change="tabChanged"
              @reset-tab="tab = -1"
              />
          </keep-alive>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProcessModel   from '../components/Ui/ProcessModel.vue';
import ActivationCode from '../components/Register/ActivationCode.vue';
import AdminInfo      from '../components/Register/AdminInfo.vue';
import CompanyInfo    from '../components/Register/CompanyInfo.vue';
import ReviewInfo     from '../components/Register/ReviewInfo.vue';
import NewIndividual  from '../components/Register/NewIndividual.vue';

export default {

  components: {
    ProcessModel,
    ActivationCode,
    AdminInfo,
    CompanyInfo,
    ReviewInfo,
    NewIndividual,
  },

  props: ['data'],

  data() {
    return {
      stage: 0,
      maxStage: 0,
      tab: -1,
      geContractor: false,
      stageComponents: [
        'activation-code',
        'admin-info',
        'company-info',
        'review-info',
        'payment',
      ],
      processModel: [
        {
          icon: 'fa fa-search',
          title: t('register.activation_code'),
          percentage: 100,
        },
        {
          icon: 'fa fa-users',
          title: t('register.admin_info'),
          percentage: 100,
        },
        {
          icon: 'fa fa-building-o',
          title: t('register.company_info'),
          percentage: 100,
        },
        {
          icon: 'fa fa-list-alt',
          title: t('register.review_info'),
          percentage: 100,
        },
      ],
      geMemberIds: this.data.geMemberIds
    };
  },

  methods: {
    stageChanged(stage) {
      $("html, body").animate({ scrollTop: 100 }, "slow");

      this.maxStage = stage;
      this.stage = stage;
    },

    tabChanged(info) {
      this.stage = info.stage;
      this.tab = info.tab;
    },
  },
};
</script>
<style>
.bottomMargin {
  margin-bottom: 20px;
}

.modalMargin {
  margin-top: 30px;
  text-align: left;
}

.logo {
  top: 40px !important;
}

.navBtn {
  width: 100px;
}

.required {
  color: #e32;
  display: inline;
}
</style>
